import React, { FC } from 'react';
import { Trans } from '@lingui/macro';

import { Link } from '@rover/kibble/core';
import { ZIndex } from '@rover/kibble/styles';
import { useTheme } from '@rover/kibble/themes';

type Props = {
  href?: string;
};

const SkipToMainContentLink: FC<Props> = ({ href = '#base-content' }) => {
  const theme = useTheme();
  return (
    <Link
      href={href}
      padding="4x"
      data-testid="skip-to-main-content-link"
      sx={{
        position: 'absolute',
        left: '50%',
        backgroundColor: theme.background.success,
        border: '1px solid transparent',
        borderBottomLeftRadius: theme.radii.secondary,
        borderBottomRightRadius: theme.radii.secondary,
        transition: 'transform 0.3s',
        zIndex: ZIndex.MODAL_BACKGROUND.toNumber() - 1,
        transform: 'translate(-50%, -200%)',
        '> span': {
          color: theme.textColor.success,
        },
        '&:focus': {
          '> span': {
            color: theme.textColor.success,
          },
          transform: 'translate(-50%, 0%)',
        },
      }}
    >
      <Trans comment="Accessibility link for keyboard users to skip header elements">
        Skip to content
      </Trans>
    </Link>
  );
};

export default SkipToMainContentLink;
